import React, { useEffect, useState } from "react";
import { FaRegEyeSlash, FaEye, FaUser, FaLock } from "react-icons/fa";
import { Formik, Form } from "formik";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getValuesFromLocalstorage } from "../../../components/Helpers";
import {
  requestBackgroundImage,
  requestLoginAction,
  setResetStateLogin,
} from "../../../Redux/LoginState/LoginActionCreator";
import { toast } from "react-toastify";
import { SignupSchema } from "../../../components/Helpers";
import { useSelector } from "react-redux";
import datacloud from "../../../Assets/data-cloud.png";
import FormField from "../../../components/FormField";
import FormButton from "../../../components/FormButton";
import { TAILWIND_CLASSES } from "../../../Constants/theme";
import Logo from "../../../components/Logo";
import Uni_Logo from "../../../Assets/DataCloud.jpeg";

function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const LoginReducerState = useSelector((state) => state.LoginReducer);

  const loginAction = (values) => {
    dispatch(requestLoginAction(values));
  };

  const BackgroundImageReducer = useSelector((state) => state.FileReducer);

  useEffect(() => {
    if (
      LoginReducerState.loginResponse?.userDetails &&
      !LoginReducerState.isLoading
    ) {
      navigate("/", { replace: true });
      dispatch(setResetStateLogin());
    }

    if (
      LoginReducerState.loginResponse?.message &&
      !LoginReducerState.isLoading
    ) {
      setResetPassword(true);
    }
  }, [LoginReducerState]);

  return (
    <div className="w-full">
      {!resetPassword ? (
        <Formik
          initialValues={{
            userName: "",
            password: "",
          }}
          validationSchema={SignupSchema}
          onSubmit={(values, { setSubmitting }) => {
            loginAction(values);
            setTimeout(() => {
              setSubmitting(false);
            }, 1000);
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <Form className="space-y-6" onSubmit={handleSubmit}>
              {/* Logo */}
              <div className="flex justify-center mb-6">
                <img 
                  src={Uni_Logo} 
                  alt="Logo" 
                  className="w-32 h-auto transform hover:scale-105 transition-transform duration-300" 
                />
              </div>

              {/* Form Fields */}
              <div className="space-y-5">
                <FormField
                  label="Username"
                  type="text"
                  name="userName"
                  value={values.userName}
                  onChange={handleChange}
                  placeholder="Enter your username"
                  error={errors.userName}
                  touched={touched.userName}
                  icon={<FaUser className="text-gray-400" />}
                  required
                  className="bg-white/5 border-gray-600 text-black placeholder-gray-400 focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-200"
                />

                <FormField
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  error={errors.password}
                  touched={touched.password}
                  icon={ 
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="text-gray-400 hover:text-gray-300 transition-colors duration-200"
                    >
                      {showPassword ? <FaEye /> : <FaRegEyeSlash />}
                    </button>
                  }
                  required
                  className="bg-white/5 border-gray-600 text-black placeholder-gray-400 focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-200"
                />
              </div>

              {/* Forgot Password Link */}
              <div className="flex justify-end">
                <Link
                  className="text-sm text-primary hover:text-primaryDark transition-colors duration-200"
                  to="/resetPassword"
                >
                  Forgot Password?
                </Link>
              </div>

              {/* Submit Button */}
              <FormButton
                type="submit"
                fullWidth
                loading={isSubmitting || LoginReducerState.isLoading}
                disabled={isSubmitting || LoginReducerState.isLoading}
                className="bg-primary hover:bg-primaryDark text-white font-medium py-3 rounded-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200"
              >
                {isSubmitting || LoginReducerState.isLoading ? (
                  <span className="flex items-center justify-center">
                    {/* <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg> */}
                    Signing in...
                  </span>
                ) : (
                  "Sign In"
                )}
              </FormButton>
            </Form>
          )}
        </Formik>
      ) : (
        <div className="text-center py-8">
          <div className="mb-6">
            <Logo size="md" />
          </div>
          <div className="bg-white/10 backdrop-blur-lg rounded-xl p-6 border border-white/20">
            <p className="mb-4 text-gray-300">Your password has expired.</p>
            <Link
              className="inline-flex items-center justify-center px-6 py-3 bg-primary hover:bg-primaryDark text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-200"
              to="/resetPassword"
            >
              Reset Password
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}

export default LoginForm;
